import axios from "axios";

import { API as Config, app as AppConfig } from "../config";

const $http = axios.create(Config);

$http.interceptors.request.use(config => {
  if (AppConfig.mode === "development") console.log(config);
  return config;
});

$http.interceptors.response.use(
  response => {
    if (AppConfig.mode === "development") console.log(response);
    return response;
  },
  err => {
    if (AppConfig.mode === "development") console.log(err);
    return err;
  }
);

export default $http;
